import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../../commons/services/http.service';
import { INTERCONEXION_GATEWAY, INTERCONEXION_ICOIJ, INTERCONEXION_METHOD_VALIDARCORREOAUTOENROLAMIENTO } from '../../../app-module.token';
import { HttpHeaders } from '@angular/common/http';
import { postValidarCorreoInterface } from './validarSolicitud.interface';
import { BaseReponseGeneric } from '../../../commons/class/BaseReponseGeneric.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ValidarSolicitudService {

    private httpS: HttpService = inject(HttpService);
    private icoj_gateway = inject(INTERCONEXION_GATEWAY);
    private icoj = inject(INTERCONEXION_ICOIJ);
    private validarCorreo = inject(INTERCONEXION_METHOD_VALIDARCORREOAUTOENROLAMIENTO);

    /**
     * Valida Correo
     * @param guid 
     * @returns 
     */
    actualizarGuid(guid: postValidarCorreoInterface): Observable<BaseReponseGeneric<boolean>> {
        const headers = new HttpHeaders();
        const url = `${this.icoj_gateway}${this.icoj}${this.validarCorreo}`;
        return this.httpS.postRequest(url, guid, headers) as Observable<BaseReponseGeneric<boolean>>
    }


}